import { List } from 'immutable';
import { fundDocTypeConstants } from '../constants';

export function fund_doc_types(state = {}, action) {
  switch (action.type) {
    case fundDocTypeConstants.FUND_DOC_TYPE_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case fundDocTypeConstants.FUND_DOC_TYPE_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case fundDocTypeConstants.FUND_DOC_TYPE_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case fundDocTypeConstants.FUND_DOC_TYPE_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case fundDocTypeConstants.FUND_DOC_TYPE_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case fundDocTypeConstants.FUND_DOC_TYPE_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case fundDocTypeConstants.FUND_DOC_TYPE_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case fundDocTypeConstants.FUND_DOC_TYPE_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const fundDocTypeIndex = state.items.findIndex(val => val.id == action.response.id);

      if (fundDocTypeIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(fundDocTypeIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case fundDocTypeConstants.FUND_DOC_TYPE_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case fundDocTypeConstants.FUND_DOC_TYPE_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case fundDocTypeConstants.FUND_DOC_TYPE_DELETE_SUCCESS: {
      const { fundDocTypeId } = action;

      if (!state.items) {
        return state;
      }

      const fundDocTypeIndex = state.items.findIndex(val => val.id == fundDocTypeId);

      if (fundDocTypeIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(fundDocTypeIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case fundDocTypeConstants.FUND_DOC_TYPE_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };

    default:
      return state;
  }
}
